import CustomerProjectModelBase from '../_generated/modelBases/customer-project-model-base';

export default class CustomerProjectModel extends CustomerProjectModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
